import { Injectable } from '@angular/core';
import { SqlAdapterService, SqlStatement } from 'src/app/common/sharedServices/sql/sql-adapter.service';
import { Ricambio } from 'src/app/common/models/Ricambio';

@Injectable({
  providedIn: 'root'
})
export class RicambiSqlAdapterService {
  // internalID è id univoco che consente di non vincolarsi a aziCdazi + idprodotto + idintervento come chiavi primarie
  private readonly SCHEMA = `(
    internalId INTEGER PRIMARY KEY,

    aziCdazi VARCHAR(3) NOT NULL,
    idProdotto INTEGER NOT NULL,
    idIntervento INTEGER,
    codiceProdotto VARCHAR(100),
    descrizioneProdotto VARCHAR(100),

    idMatricola INTEGER,
    codiceUnitaMisura VARCHAR(10),
    codiceMatricola VARCHAR(100),
    idCommessa INTEGER,
    codiceCommessa VARCHAR(100),

    codiceMagazzinoSelezionato VARCHAR(30),

    oggetto TEXT NOT NULL

  );`;

  constructor(private sql: SqlAdapterService) {
    this.initTable();
  }

  private async initTable() {
    const query = `CREATE TABLE IF NOT EXISTS Ricambi ${this.SCHEMA}`;
    try {
      const created = await this.sql.execute({
        statement: query,
      });
      console.log('Created table Ricambi ? ', created);
    } catch (error) {
      console.error('Errore while creating table Ricambi', error);
    }
  }

  async inserisciRicambi(ricambi: Ricambio[], idInterventoAppartenenza?: number) {
    const insertQueries = ricambi.map(ricambio => this.getSingleInsertQuery(ricambio, idInterventoAppartenenza));
    try {
      const inserted = await this.sql.executeSet(insertQueries);
      console.log('Inserted into table Ricambi ? ', inserted);
    } catch (error) {
      console.error('Errore while inserting data into table Ricambi', error);
    }
  }

  private getSingleInsertQuery(ricambio: Ricambio, idInterventoAppartenenza?: number): SqlStatement {
    if (idInterventoAppartenenza) {
      const query = `INSERT INTO Ricambi (aziCdazi, idProdotto, codiceProdotto, descrizioneProdotto, idIntervento, codiceMagazzinoSelezionato, oggetto) VALUES (?, ?, ?, ?, ?, ?, ?)`;
      return {
        statement: query,
        values: [
          ricambio.aziCdazi,
          ricambio.idProdotto,
          ricambio.codiceProdotto,
          ricambio.descrizioneProdotto,
          idInterventoAppartenenza,
          (ricambio.codiceMagazzinoSelezionato || '').trim(),
          JSON.stringify(ricambio)
        ]
      };
    } else {
      const query = `INSERT INTO Ricambi (aziCdazi, idProdotto, codiceProdotto, descrizioneProdotto, codiceUnitaMisura, codiceMagazzinoSelezionato, oggetto) VALUES (?, ?, ?, ?, ?, ?, ?)`;
      return {
        statement: query,
        values: [
          ricambio.aziCdazi,
          ricambio.idProdotto,
          ricambio.codiceProdotto,
          ricambio.descrizioneProdotto,
          ricambio.codiceMisuraApplicata,
          (ricambio.codiceMagazzinoSelezionato || '').trim(),
          JSON.stringify(ricambio)
        ]
      };
    }
  }

  async updateRicambio(ricambio: Ricambio) {
    const query = `
      UPDATE Ricambi
      SET oggetto = ?, codiceMagazzinoSelezionato = ?
      WHERE (idIntervento = ? AND idProdotto = ? AND aziCdazi = ? AND codiceMagazzinoSelezionato = ?);
    `;

    const deposito = (ricambio.codiceMagazzinoSelezionato || '').trim();

    try {
      const updated = await this.sql.execute({
        statement: query,
        values: [
          JSON.stringify(ricambio),
          deposito,
          ricambio.idIntervento,
          ricambio.idProdotto,
          ricambio.aziCdazi,
          deposito
        ]
      });
      console.log('Update existing ricambio  ? ', updated);
    } catch (error) {
      console.error('Errore while updating data from table Ricambi', error);
    }
  }

  async rimuoviRicambi(legatiAdIntervento = false) {
    if (legatiAdIntervento) {
      const query = `DELETE FROM Ricambi WHERE idIntervento IS NOT NULL ;`;
      try {
        const removed = await this.sql.execute({
          statement: query
        });
        console.log('Removed all Ricambi bound to operations ? ', removed);
      } catch (error) {
        console.error('Errore while removing from table Ricambi', error);
      }
    } else {
      const query = `DELETE FROM Ricambi ;`;
      try {
        const removed = await this.sql.execute({
          statement: query
        });
        console.log('Removed all Ricambi ? ', removed);
      } catch (error) {
        console.error('Errore while removing from table Ricambi', error);
      }
    }
  }

  /**
   * Metodo originale (con l'aggiunta del filtro per deposito).
   * Non più utilizzato, anche se funzionava correttamente col deposito, perché non utilizzava il limit
   * e quindi quando per esempio si cercava per tutti gli automezzi e c'erano tipo 21k e oltre di ricambi
   * offline li restituiva tutti facendo diventare l'app lenta (oltre a metterci tanto nel caricamento).
   * Probabilmente già prima dell'aggiunta del filtro deposito era sbagliato.
   * Metodo nuovo sotto che gestisce il limit 100 quando non c'è il filtro deposito (ovvero che automezzi ha TUTTI come opzione)
   * e il limit combinato con la logica di filtraggio per quando c'è il filtro deposito.
   */
  // async fetchRicambiDaAnagrafica(aziCdazi: string, filtroCodice: string, filtroDescrizione: string, filtroDeposito?: string): Promise<Ricambio[]> {
  //   const selectField = `SELECT oggetto FROM Ricambi WHERE (aziCdazi = ? AND codiceProdotto LIKE ? AND descrizioneProdotto LIKE ?); `;
  //   try {
  //     const records = await this.sql.execute({
  //       statement: selectField,
  //       // values: [aziCdazi, `%${filtroCodice}%`, `%${filtroDescrizione}%`]
  //       values: [aziCdazi, `%${filtroCodice || ''}%`, `%${filtroDescrizione || ''}%`]
  //     });

  //     const result = [];
  //     for (let k = 0; k < records.values?.length; k++) {
  //       result.push(records.values[k]);
  //     }

  //     // Trasformo ogni riga nel relativo Ricambio
  //     let ricambi: Ricambio[] = result.map(row => JSON.parse(row.oggetto));

  //     // Se è selezionato "Tutti" oppure non arriva alcun deposito, non applico il filtro
  //     if (!filtroDeposito || filtroDeposito.trim().length === 0) {
  //       console.debug('Select ricambi result', ricambi);
  //       return ricambi;
  //     }

  //     const depositoDaFiltrare = filtroDeposito.trim();

  //     ricambi = ricambi.filter((ricambio: Ricambio) => {
  //       // Se il ricambio non ha informazioni sui magazzini, allora non può appartenere al deposito selezionato, quindi lo escludo
  //       if (!ricambio.esistenzaMagazzino || ricambio.esistenzaMagazzino.length === 0) {
  //         return false;
  //       }

  //       // Controllo se almeno uno dei magazzini del ricambio corrisponde al deposito selezionato
  //       return ricambio.esistenzaMagazzino.some(magazzino =>
  //         (magazzino.codiceMagazzino || '').trim() === depositoDaFiltrare
  //       );
  //     });

  //     console.debug('Select ricambi result filtrati per deposito', depositoDaFiltrare, ricambi);
  //     return ricambi;
  //   } catch (error) {
  //     console.error('Errore while selecting data from table ricambi', error);
  //     return [];
  //   }
  // }

  async fetchRicambiDaAnagrafica(
    aziCdazi: string,
    filtroCodice: string,
    filtroDescrizione: string,
    filtroDeposito?: string
  ): Promise<Ricambio[]> {
    const filtroCodiceSafe = filtroCodice || '';
    const filtroDescrizioneSafe = filtroDescrizione || '';

    try {
      // Caso semplice: nessun filtro deposito -> prendo direttamente i primi 100
      if (!filtroDeposito || filtroDeposito.trim().length === 0) {
        const selectField = `
          SELECT oggetto
          FROM Ricambi
          WHERE aziCdazi = ?
            AND codiceProdotto LIKE ?
            AND descrizioneProdotto LIKE ?
          LIMIT 100;
        `;

        const records = await this.sql.execute({
          statement: selectField,
          values: [aziCdazi, `%${filtroCodiceSafe}%`, `%${filtroDescrizioneSafe}%`]
        });

        const result = [];
        for (let k = 0; k < records.values?.length; k++) {
          result.push(records.values[k]);
        }

        const ricambi: Ricambio[] = result.map(row => JSON.parse(row.oggetto));
        console.debug('Select ricambi result', ricambi);
        return ricambi;
      }

      // Caso con filtro deposito -> scorro a blocchi e filtro in memoria
      const depositoDaFiltrare = filtroDeposito.trim();
      const risultati: Ricambio[] = [];

      const chunkSize = 500;
      let offset = 0;
      let hasMoreRows = true;

      while (risultati.length < 100 && hasMoreRows) {
        const selectField = `
          SELECT oggetto
          FROM Ricambi
          WHERE aziCdazi = ?
            AND codiceProdotto LIKE ?
            AND descrizioneProdotto LIKE ?
          LIMIT ${chunkSize} OFFSET ${offset};
        `;

        const records = await this.sql.execute({
          statement: selectField,
          values: [aziCdazi, `%${filtroCodiceSafe}%`, `%${filtroDescrizioneSafe}%`]
        });

        const rows = [];
        for (let k = 0; k < records.values?.length; k++) {
          rows.push(records.values[k]);
        }

        if (!rows.length) {
          hasMoreRows = false;
          break;
        }

        const ricambiChunk: Ricambio[] = rows.map(row => JSON.parse(row.oggetto));

        const ricambiFiltrati = ricambiChunk.filter((ricambio: Ricambio) => {
          if (!ricambio.esistenzaMagazzino || ricambio.esistenzaMagazzino.length === 0) {
            return false;
          }

          return ricambio.esistenzaMagazzino.some(magazzino =>
            (magazzino.codiceMagazzino || '').trim() === depositoDaFiltrare
          );
        });

        risultati.push(...ricambiFiltrati);

        if (rows.length < chunkSize) {
          hasMoreRows = false;
        } else {
          offset += chunkSize;
        }
      }

      const risultatiFinali = risultati.slice(0, 100);
      console.debug('Select ricambi result filtrati per deposito', depositoDaFiltrare, risultatiFinali);
      return risultatiFinali;
    } catch (error) {
      console.error('Errore while selecting data from table ricambi', error);
      return [];
    }
  }

  async fetchRicambiDiIntervento(
    aziCdazi: string,
    filtroCodice: string,
    filtroDescrizione: string,
    idIntervento: number
  ): Promise<Ricambio[]> {
    const selectField = `SELECT oggetto FROM Ricambi WHERE (aziCdazi = ? AND idIntervento = ? AND codiceProdotto LIKE ? AND descrizioneProdotto LIKE ?); `;
    try {
      const records = await this.sql.execute({
        statement: selectField,
        values: [aziCdazi, idIntervento, `%${filtroCodice}%`, `%${filtroDescrizione}%`]
      });

      const result = [];
      for (let k = 0; k < records.values?.length; k++) {
        result.push(records.values[k]);
      }
      console.debug('Select ricambi result', result);
      return result.map(row => JSON.parse(row.oggetto));
    } catch (error) {
      console.error('Errore while selecting data from table ricambi', error);
      return [];
    }
  }
}